/* eslint-disable no-underscore-dangle */
import { useState, useEffect, useContext } from 'react';

import { useLazyQuery } from '@apollo/client';

import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import { GET_INTEGRATIONS_STATUS } from './graphql';

export function useGetIntegrationsStatus({ storeId } = {}) {
  const { setErrorMessage } = useContext(GeneralContext);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({
    cliqueRetire: '',
    correios: '',
    vtex: '',
    memphis: '',
  });
  const [GetIntegrationsStatus] = useLazyQuery(GET_INTEGRATIONS_STATUS, {
    fetchPolicy: 'network-only',
  });

  async function getIntegrationsStatus(newStoreId) {
    setLoading(true);
    try {
      const res = await GetIntegrationsStatus({
        variables: { storeId: newStoreId || storeId },
      });
      if (res.data.getIntegrationsStatus.code === 200) {
        const { cliqueRetire, correios, vtex, memphis } =
          res.data.getIntegrationsStatus.status;
        setStatus({
          cliqueRetire,
          correios,
          vtex,
          memphis,
        });
      } else {
        setErrorMessage('Algo deu errado, tente novamente mais tarde.');
      }
    } catch (e) {
      setErrorMessage('Algo deu errado, tente novamente mais tarde.');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (storeId) {
      getIntegrationsStatus(storeId);
    }
  }, [storeId]);

  return {
    getIntegrationsStatus,
    status,
    setStatus,
    loading,
  };
}
